import { ApiRequestError } from '@/lib/httpClient'

/**
 * The per-organisation rule in AdvicePrep: a client user or client admin may only act on a
 * meeting for an organisation they are on in Xero, or have been given Additional Access to in
 * Advisory Mapping. The API is the real gate - everything here is so the UI can say why rather
 * than failing silently.
 */
export const ADVISORY_ACCESS_DENIED_CODE = 'ADVISORY_ORG_ACCESS_DENIED'

// Kept word-for-word in step with AdvisoryOrgAccess.DeniedMessage on the server.
export const ADVISORY_ACCESS_DENIED_MESSAGE =
  "You are not permitted to access this client's information. You need Xero access, or ask your admin to add you under Additional Access in Advisory Mapping."

export function createAdvisoryAccessGuard(canInteract: boolean | undefined, onBlocked: () => void) {
  const isAllowed = canInteract !== false

  return {
    canInteract: isAllowed,
    blockedTooltip: isAllowed ? '' : ADVISORY_ACCESS_DENIED_MESSAGE,
    guard: (action: () => void) => (isAllowed ? action() : onBlocked()),
  }
}

export function isAdvisoryAccessDenied(error: unknown): boolean {
  if (!(error instanceof ApiRequestError) || error.status !== 403) return false
  if (error.code === ADVISORY_ACCESS_DENIED_CODE) return true
  return (error.payload as { code?: string } | undefined)?.code === ADVISORY_ACCESS_DENIED_CODE
}
